import React, { lazy } from "react";

const LazyReferences = lazy(() => import("./References"));

const References = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyReferences {...props} />;

export default References;
